import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { eligibility } from '../../Helpers/validators';
import { eventPropType } from '../../Constants/eventTypes';
import PromoterField from './PromoterField';
import SecurityField from './SecurityField';
import LossClaimsField from './LossClaimsField';
import { Button } from '@jauntin/react-ui';

const AlertNotEligible = ({ show }) => (
  <Alert show={show} variant="primary" className="mw--635 mx-auto">
    <i className="fal fa-info-circle alert__icon" />
    <div className="alert__text">
      Unfortunately, we cannot provide a policy from our online special event
      insurance program given the details provided. For more information, please
      call <span className="text-nowrap">(844) 747-6240</span>.
    </div>
  </Alert>
);
AlertNotEligible.propTypes = {
  show: PropTypes.bool.isRequired,
};

const Edit = ({ eventType, back, confirm, valid, showAlert }) => (
  <>
    <AlertNotEligible show={showAlert} />
    {eventType.lossClaims && (
      <LossClaimsField name="lossClaims" validate={[eligibility]} />
    )}
    {eventType.security && (
      <SecurityField name="security" validate={[eligibility]} />
    )}
    {eventType.promoter && (
      <PromoterField name="promoter" validate={[eligibility]} />
    )}
    <div className="row justify-content-center mt-5">
      <div className="col-auto">
        <Button onClick={back} text="Back" className="btn-link" />
      </div>
      <div className="col-auto">
        <Button
          disabled={!valid}
          onClick={confirm}
          text="Continue"
          className="btn-primary"
        />
      </div>
    </div>
  </>
);
Edit.propTypes = {
  eventType: eventPropType.isRequired,
  back: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  showAlert: PropTypes.bool.isRequired,
};

export default Edit;
